/* istanbul ignore file */
import ShortForm_Multiple from "./ShortForm_Multiple";
import ShortForm_OneSteps from "./ShortForm_OneSteps";

export default {
  ShortForm_Multiple,
  ShortForm_OneSteps,
};
